// 点赞与收藏接口
import request from '@/utils/request'

//点赞
//点赞列表
export function AssistLoad(params) {
    return request({
        url: '/api/Assist/Load',
        method: 'get',
        params
    })
}

//添加点赞
export function AssistAdd(data) {
    return request({
        url: '/api/Assist/Add',
        method: 'post',
        data
    })
}

export function GetCertifyUrl(params) {
    return request({
        url: '/api/PmiUser/GetCertifyUrl',
        method: 'get',
        params
    })
}

// 取消点赞
export function AssistDelete(params) {
    return request({
        url: '/api/Assist/Delete',
        method: 'get',
        params
    })
}
// 是否点赞
export function AssistIsAssist(params) {
    return request({
        url: '/api/Assist/IsAssist',
        method: 'get',
        params
    })
}
// 上传图片
export function uploadDoc(data) {
    return request({
        url: '/resource/File/UploadPic',
        method: 'post',
        data
    })
}




//   收藏
// 收藏列表
export function CollectionLoad(params) {
    return request({
        url: '/api/Collection/Load',
        method: 'get',
        params
    })
}

//添加收藏
export function CollectionAdd(data) {
    return request({
        url: '/api/Collection/Add',
        method: 'post',
        data
    })
}

// 是否收藏
export function CollectionIsColl(params) {
    return request({
        url: '/api/Collection/IsCollection',
        method: 'get',
        params
    })
}

// 删除收藏 
export function CollectionDele(params) {
    return request({
        url: '/api/Collection/Delete',
        method: 'get',
        params
    })
}

//搜索接口
export function SearchAllHome(params) {
    return request({
        url: '/api/Home/SearchAll',
        method: 'get',
        params
    })
}

// 获取地市
export function getCity(params) {
    return request({
        url: '/api/PmiDept/GetCity',
        method: 'get',
        params
    })
}

// 获取列表
export function getList(params) {
    return request({
        url: '/api/PmiDictionary/GetByTypeId',
        method: 'get',
        params
    })
}
// 获取随机数
export function GetOriginal(params) {
    return request({
        url: '/api/CAUser/GetOriginal',
        async: false,
        method: 'get',
        params
    })
}

// 生成报文登录
export function SignedOriginal(params) {
    return request({
        url: '/api/CAUser/SignedOriginal',
        async: false,
        method: 'get',
        params
    })
}